<template>
  <section>
    <div class="d-flex justify-content-between align-items-center mb-2">
      <div>
        <p class="text-muted mb-0">Vos derniers dossiers et les projets à compléter.</p>
      </div>
      <b-button variant="outline-primary" :disabled="loading" @click="fetchOverview">Actualiser</b-button>
    </div>
    <div v-if="loading" class="text-center p-3" role="status"><b-spinner label="Chargement du tableau de bord" /></div>
    <b-alert v-else-if="error" show variant="danger">{{ error }}</b-alert>
    <template v-else-if="overview">
      <b-row>
        <b-col v-if="overview.latest_offers !== null" lg="6">
          <dashboard-records title="Les 5 dernières offres" :items="overview.latest_offers" />
        </b-col>
        <b-col v-if="overview.latest_projects !== null" lg="6">
          <dashboard-records title="Les 5 derniers projets gagnés" :items="overview.latest_projects" project />
        </b-col>
      </b-row>
      <dashboard-records v-if="overview.projects_without_budget !== null"
                         :title="`Projets sans budget (${overview.projects_without_budget.total})`"
                         :items="overview.projects_without_budget.data" project>
        <b-pagination v-if="overview.projects_without_budget.total > 10" v-model="budgetPage"
                      :total-rows="overview.projects_without_budget.total" :per-page="10" @input="fetchOverview" />
      </dashboard-records>
      <b-alert v-if="overview.latest_offers === null && overview.latest_projects === null && overview.projects_without_budget === null"
               show variant="info">Bienvenue. Aucun dossier n’est accessible avec vos autorisations actuelles.</b-alert>
    </template>
    <dashboard-manager v-if="$can('read_dashboard', 'Statistiques')" />
  </section>
</template>
<script>
import {BRow, BCol, BButton, BSpinner, BAlert, BPagination} from 'bootstrap-vue';
import dashboardService from '@/store/services/dashboard-service';
import {dashboardErrorMessage} from './dashboard-utils';
import DashboardRecords from './DashboardRecords.vue';
import DashboardManager from './DashboardManager.vue';
export default {
  components: {BRow, BCol, BButton, BSpinner, BAlert, BPagination, DashboardRecords, DashboardManager},
  data: () => ({overview: null, loading: false, error: '', budgetPage: 1, requestId: 0}),
  created() { this.fetchOverview(); },
  beforeDestroy() { this.requestId += 1; },
  methods: {
    async fetchOverview() {
      const requestId = ++this.requestId;
      this.loading = true;
      this.error = '';
      try {
        const overview = await dashboardService.overview({budget_page: this.budgetPage});
        if (requestId === this.requestId) this.overview = overview;
      } catch (error) {
        if (requestId === this.requestId) this.error = dashboardErrorMessage(error, 'Impossible de charger le tableau de bord. Réessayez avec Actualiser.');
      } finally {
        if (requestId === this.requestId) this.loading = false;
      }
    },
  },
};
</script>
